module.exports = __webpack_public_path__ + "img/american-credit-prequalify-promptly-320w.a696b55.jpg";